<template>
  <div class="host-common">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>功能管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">功能管理</div>
      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-text">功能的设置</div> 
    </div>

    <div class="host-common-content">
      <Form :model="formInline" style="width:800px;">
        <FormItem>
          <Checkbox v-model="formInline.exRegister">
            开启展商注册
            <span class="check_box">（开启后展商可以自助报名）</span>
          </Checkbox>
        </FormItem>
        <FormItem>
          <Checkbox v-model="formInline.exAudit">
            开启审核
            <span class="check_box">（开启后注册的展商需审核后才显示）</span>
          </Checkbox>
        </FormItem>
        <FormItem>
          <Checkbox v-model="formInline.exPreRegistration">
            开启参观预登记
          </Checkbox>
        </FormItem>
        <FormItem>
          <Checkbox v-model="formInline.exFreeExperience">
            开启展品免费体验功能
          </Checkbox>
        </FormItem>
        <FormItem>
          <Checkbox v-model="formInline.exAskStamps">
            开启观众问卷跳过功能
          </Checkbox>
        </FormItem>
        <FormItem>
          <Checkbox v-model="formInline.exIsShow">
            开启展商显示限制
            <span class="check_box">（排行榜中的展商只显示限制数量，并在底部显示“主办已屏蔽部分展商”）</span>
          </Checkbox>
        </FormItem>
        <FormItem v-if="formInline.exIsShow">
          <InputNumber :max="99999" :min="1" v-model="formInline.exShowNum"></InputNumber>
        </FormItem>
        <FormItem>
          <Checkbox v-model="formInline.exAutoAudit">
            展商供需自动审核
          </Checkbox>
          <p v-if="formInline.exAutoAudit">屏蔽字库</p>
          <Input v-if="formInline.exAutoAudit" style="width:370px;" type="textarea" :rows="4" placeholder="请输入屏蔽内容" v-model="formInline.exShield" />
        </FormItem>
        <FormItem>
          <Checkbox v-model="formInline.userAutoAudit">
            用户供需自动审核
          </Checkbox>
          <p v-if="formInline.userAutoAudit">屏蔽字库</p>
          <Input v-if="formInline.userAutoAudit" style="width:370px;" type="textarea" :rows="4" placeholder="请输入屏蔽内容" v-model="formInline.userShield" />
        </FormItem>
      </Form>
      <div>
        <Button style="width:68px;height:32px;margin-right:10px;" type="primary" :loading="loading" @click="handleSubmit()">保存</Button>
        <Button style="width:68px;height:32px;" @click="init();">取消</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "host-common-function",
  data() {
    return {
      formInline: {
        exRegister: false,
        exAudit: false,
        exPreRegistration: false,
        exFreeExperience: false,
        exAskStamps: false,
        exIsShow: false,
        exShowNum: 1,
        exAutoAudit: false,
        exShield: "",
        userAutoAudit: false,
        userShield: "",
      },
      loading: false,
    }
  },
  methods: {
    init() {

    },
    handleSubmit() {
      let req = {
        exRegister: this.formInline.exRegister,
        exAudit: this.formInline.exAudit,
        exPreRegistration: this.formInline.exPreRegistration,
        exFreeExperience: this.formInline.exFreeExperience,
        exAskStamps: this.formInline.exAskStamps,
        exIsShow: this.formInline.exIsShow,
        exShowNum: this.formInline.exShowNum,
        exAutoAudit: this.formInline.exAutoAudit,
        exShield: this.formInline.exShield,
        userAutoAudit: this.formInline.userAutoAudit,
        userShield: this.formInline.userShield,
      }
      console.log(req);
    }
  }
}
</script>

<style lang="scss" scoped>
.host-common {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
  &-content {
    min-width: 600px;
    margin: 30px;
    padding: 80px 0 100px 200px;
    background-color: #fff;
    .check_box {
      font-size: 14px;
      color: #999;
    }
  }
}
</style>